import { ptBrCommonFieldsTranslations } from "../common";

export const role = {
  name: "Perfil |||| Perfis",
  fields: {
    id: "ID",
    name: "Nome",
    description: "Descrição",
    permissions: "Permissões",
    permissionIds: "Permissões",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
};
